const fileVisibilityTypesMap = {
  public: 'public',
  private: 'private',
}

export default fileVisibilityTypesMap
